<div [class.row]="isInline()" [class.justified]="isJustified()">
  <div [class.text-end]="isInlineOnly()" [ngClass]="isInline() ? 'col-sm-' + labelColumns : ''" *ngIf="showLabel">
    <label [class.col-form-label]="isInline()" [class.text-nowrap]="labelNowrap" class="form-label fw-bold">{{ name }}</label>
  </div>
  <div [ngClass]="isInline() ? 'col-sm-' + (12 - labelColumns) : ''" class="position-relative">
    <p-inputgroup [class.flex-column]="appendElements.length === 0">
      <p-inputgroup-addon *ngFor="let item of prependElements" class="col-auto">
        <ng-container *ngTemplateOutlet="item"></ng-container>
      </p-inputgroup-addon>

      <ng-container *ngIf="!customInput" [ngSwitch]="type" class="flex-grow-1 d-flex">
        <input
          *ngSwitchCase="InputFieldType.Text"
          pInputText
          [type]="type"
          pSize="small"
          [formErrorDirective]="formName"
          [attr.tabindex]="tabIndex"
          [formControl]="control"
          [placeholder]="placeholder ? placeholder : name"
          [maxlength]="maxLen"
          class="w-100"
          [class.rounded-end]="appendElements.length === 0"
        />

        <input
          *ngSwitchCase="InputFieldType.Phone"
          pInputText
          type="tel"
          autocomplete="tel"
          pSize="small"
          (keypress)="onKeyPress($event)"
          [formErrorDirective]="formName"
          [attr.tabindex]="tabIndex"
          [formControl]="control"
          [placeholder]="placeholder ? placeholder : name"
          [maxlength]="maxLen"
          class="w-100"
          [class.rounded-end]="appendElements.length === 0"
        />

        <p-password
          *ngSwitchCase="InputFieldType.Password"
          size="small"
          [formControl]="control"
          [formErrorDirective]="formName"
          [placeholder]="placeholder || name"
          [maxlength]="maxLen"
          [attr.tabindex]="tabIndex"
          [feedback]="false"
          class="flex-grow-1 d-flex"
          class="w-100"
          [inputStyleClass]="appendElements.length === 0 ? 'rounded-end' : ''"
        ></p-password>

        <p-inputNumber
          *ngSwitchCase="InputFieldType.Number"
          size="small"
          [formControl]="control"
          [formErrorDirective]="formName"
          [placeholder]="placeholder || name"
          [attr.tabindex]="tabIndex"
          class="w-100"
          [inputStyleClass]="appendElements.length === 0 ? 'rounded-end' : ''"
        ></p-inputNumber>

        <p-datepicker
          *ngSwitchCase="InputFieldType.Date"
          size="small"
          [iconDisplay]="'input'"
          [showIcon]="true"
          [formControl]="control"
          [placeholder]="placeholder || name"
          dateFormat="yy-mm-dd"
          [attr.tabindex]="tabIndex"
        ></p-datepicker>
      </ng-container>

      <ng-container *ngIf="customInput">
        <ng-container *ngTemplateOutlet="customInput"></ng-container>
      </ng-container>
      <p-inputgroup-addon *ngFor="let item of appendElements" class="col-auto">
        <ng-container *ngTemplateOutlet="item"></ng-container>
      </p-inputgroup-addon>
    </p-inputgroup>
    <shared-ui-inputs-password-info *ngIf="showInfo" [placement]="infoPlacement"></shared-ui-inputs-password-info>
  </div>
</div>
